module.exports = __webpack_public_path__ + "static/media/classic3.41d9d3f5.jpg";